import {z} from 'zod'
import {
  type LegacyPartnerStillStoredInLocalStorage,
  type GeneratedPartnerReferrerData,
  type YCFounderReferrerData,
  type ReferralPartnerAudience,
  type SignupDealKind,
  type SignupReferralMethod,
  type SignupOffer,
} from './types'

export const ycFounderSchema: z.Schema<Omit<YCFounderReferrerData, 'type'>> =
  z.object({
    callsign: z.string(),
    founderId: z.string(),
  })

const referralPartnerAudienceSchema: z.Schema<ReferralPartnerAudience> = z.union([
  z.literal('startup'),
  z.literal('ecommerce'),
  z.literal('investor'),
  z.literal('web3'),
])

const signupDealKindSchema: z.Schema<SignupDealKind> = z.union([
  z.literal('409a'),
  z.literal('aWS5k'),
  z.literal('teaRoom'),
  z.literal('cashBonus'),
  z.literal('creditLimitIncrease'),
])
const signupReferralMethodSchema: z.Schema<SignupReferralMethod> = z.union([
  z.literal('PartnerPage'),
  z.literal('OnboardingAPI'),
])
const signupOfferSchema: z.Schema<SignupOffer> = z.object({
  id: z.string(),
  partnerId: z.string(),
  kind: signupDealKindSchema.or(z.literal('')),
  cutoffDays: z.number().optional(),
  cashBonusAmount: z.number().optional(),
  debitSpendRequirement: z.number().optional(),
  depositRequirement: z.number().optional(),
  referralMethodRequirement: signupReferralMethodSchema.optional().or(z.literal('')),
  repeatableUntilPayoutCap: z.number().optional(),
  exclusiveWithOtherDeals: z.boolean(),
})
export const generatedPartnerSchema: z.Schema<
  Omit<GeneratedPartnerReferrerData, 'type'>
> = z.object({
  callsign: z.string(),
  name: z.string(),
  frontendKey: z.string(),
  audience: referralPartnerAudienceSchema.optional().or(z.literal('')),
  offer: z.preprocess(
    s => JSON.parse(s as string),
    z.array(signupOfferSchema)
  ) as z.Schema<SignupOffer[]>,
})

export const legacyPartnerSchema: z.Schema<
  Omit<LegacyPartnerStillStoredInLocalStorage, 'type'>
> = z.object({
  frontendKey: z.string(),
})
